var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPistadePadel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3392_14345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75556 5.4429C9.19039 3.93559 11.1642 3.05817 13.2447 3.00279C15.3253 2.94741 17.343 3.71857 18.856 5.14741C20.2856 6.66277 21.0555 8.68324 20.9969 10.7655C20.9382 12.8477 20.0557 14.8217 18.5431 16.2542C17.6105 17.1948 16.4658 17.8982 15.2051 18.3052C14.1508 18.6611 13.0316 18.7832 11.9253 18.6631C10.819 18.5431 9.75207 18.1837 8.79867 17.6099L5.66933 20.7299C5.33569 20.9413 4.93996 21.0329 4.54731 20.9895C4.15467 20.946 3.78854 20.7702 3.5092 20.4909C3.22987 20.2116 3.054 19.8456 3.01055 19.453C2.9671 19.0605 3.05867 18.6648 3.27018 18.3312L6.4169 15.1765C5.843 14.2233 5.48352 13.1566 5.36343 12.0506C5.24335 10.9445 5.36553 9.82556 5.72149 8.77145C5.82327 8.44029 5.95117 8.11772 6.10396 7.80678",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9L15 18",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5C3 5.8283 3.06466 6.15339 3.1903 6.45671C3.31594 6.76002 3.50009 7.03562 3.73223 7.26777C3.96438 7.49991 4.23998 7.68406 4.54329 7.8097C4.84661 7.93534 5.1717 8 5.5 8C5.8283 8 6.15339 7.93534 6.45671 7.8097C6.76002 7.68406 7.03562 7.49991 7.26777 7.26777C7.49991 7.03562 7.68406 6.76002 7.8097 6.45671C7.93534 6.15339 8 5.8283 8 5.5C8 4.83696 7.73661 4.20107 7.26777 3.73223C6.79893 3.26339 6.16304 3 5.5 3C4.83696 3 4.20107 3.26339 3.73223 3.73223C3.26339 4.20107 3 4.83696 3 5.5Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3392_14345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPistadePadel);
export default __webpack_public_path__ + "static/media/Pista de Padel.e0ef23d7bc7a34853e4cea7c409ff84b.svg";
export { ForwardRef as ReactComponent };